
import React from "react";
// react-bootstrap components
import {
Container,
        Row,
        Col,
        Form,
        Table,
        Button
        } from "react-bootstrap";

import { library }
from '@fortawesome/fontawesome-svg-core';
import { fas }
from '@fortawesome/free-solid-svg-icons';
import { fab }
from '@fortawesome/free-brands-svg-icons';
import { far }
from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon }
from '@fortawesome/react-fontawesome';
import '../../static/css/App.css';
library.add(fas, fab, far);
function AddProduct() {
    return (
            <Container fluid>
                <Row>            
                    <Col md="12" className="my-5"><h2>General Details</h2></Col>
                    <Col md="12">                
                    <Form className="col-12">
                        <Row>
                            <Col md="6" className="">
                            <Form.Group className="mb-3 d-flex" controlId="formGroupProductName">
                                <Form.Label className="col-4">Product Name<span className="text-danger">*</span></Form.Label>
                                <Form.Control className="col-8 product-fields" type="text" placeholder="Product Name" />
                            </Form.Group>
                            <Form.Group className="mb-3 d-flex" controlId="formGroupProductCategory">
                                <Form.Label className="col-4">Category<span className="text-danger">*</span></Form.Label>
                                <Form.Control className="col-8 product-fields" type="text" />
                            </Form.Group>
                            <Form.Group className="mb-3 d-flex" controlId="formGroupProductBrand">
                                <Form.Label className="col-4">Brand<span className="text-danger">*</span></Form.Label>
                                <Form.Control className="col-8 product-fields" type="text" />
                            </Form.Group>
                            <Form.Group className="mb-3 d-flex" controlId="formGroupProductDescription">
                                <Form.Label className="col-4">Product Description<span className="text-danger">*</span></Form.Label>
                                <Form.Control as="textarea" className="col-8 product-fields" type="text" />
                            </Form.Group>
                            <Form.Group className="mb-3 d-flex" controlId="formGroupRelatedProducts">
                                <Form.Label className="col-4">Related Products<span className="text-danger">*</span></Form.Label>
                                <Form.Control className="col-8 product-fields" type="text" />
                            </Form.Group>
                            </Col>
                            <Col md="6" className="ps-2 border-start">
                            <Form.Group className="mb-3 d-flex" controlId="formGroupProductRating">
                                <Form.Label className="col-4">Ratings<span className="text-danger">*</span></Form.Label>                                
                            </Form.Group>
                            <Form.Group className="mb-3 d-flex" controlId="formGroupProductSales">
                                <Form.Label className="col-4">Sales In<span className="text-danger">*</span></Form.Label>                                
                                <Row>
            
                                    <Col key="1"  className="p-2 me-2 bg-secondary"><FontAwesomeIcon icon="fa-solid fa-globe" size="sm" style={{color: "#ffffff"}} /></Col>            
                                    <Col key="2"  className="p-2 me-2 bg-secondary"><FontAwesomeIcon icon="fa-solid fa-mobile-screen" size="sm" style={{color: "#ffffff"}} /></Col>            
                                    <Col key="3"  className="p-2 me-2 bg-secondary"><FontAwesomeIcon icon="fa-solid fa-store" size="sm" style={{color: "#ffffff"}} /></Col>            
            
                                </Row>                
                            </Form.Group>
                            <Form.Group className="mb-3 d-flex" controlId="formGroupProductAvailability">
                                <Form.Label className="col-4">Availability<span className="text-danger">*</span></Form.Label>                                
                                <Form.Check
                                    type="switch"
                                    id="custom-switch"                                    
                                    />
                            </Form.Group>
                            <Form.Group className="mb-3 d-flex" controlId="formGroupProductSudexo">
                                <Form.Label className="col-4">Sudexo<span className="text-danger">*</span></Form.Label>                                
                                <Form.Check
                                    type="switch"
                                    id="custom-switch"                                    
                                    />
                            </Form.Group>
                            <Form.Group className="mb-3 d-flex" controlId="formGroupProductWeighable">
                                <Form.Label className="col-4">Weighable<span className="text-danger">*</span></Form.Label>                                
                                <Form.Check
                                    type="switch"
                                    id="custom-switch"                                    
                                    />
                            </Form.Group>
                            <Form.Group className="mb-3 d-flex" controlId="formGroupProductStockFlag">
                                <Form.Label className="col-4">Stock Flag<span className="text-danger">*</span></Form.Label>                                
                                <Form.Check
                                    type="switch"
                                    id="custom-switch"                                    
                                    />
                            </Form.Group>
                            <Form.Group className="mb-3 d-flex" controlId="formGroupProductStock">
                                <Form.Label className="col-4">Product Stock</Form.Label>
                                <Form.Control className="col-8 product-fields" type="text" />
                            </Form.Group>
                            <Form.Group className="mb-3 d-flex" controlId="formGroupProductTags">
                                <Form.Label className="col-4">Key Tags<span className="text-danger">*</span></Form.Label>
                                <Form.Control className="col-8 product-fields" type="text" />
                            </Form.Group>
                            <Form.Group className="mb-3 d-flex" controlId="formGroupProductVideo">
                                <Form.Label className="col-4">Video Url</Form.Label>
                                <Form.Control className="col-8 product-fields" type="text" />
                            </Form.Group>
                            <Form.Group className="mb-3 d-flex" controlId="formGroupProductCode">
                                <Form.Label className="col-4">HSN/SAC Code</Form.Label>
                                <Form.Control className="col-8 product-fields" type="text" />
                            </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Table striped>
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Item Unit</th>
                                        <th>Ref. code</th>
                                        <th>Pack of</th>
                                        <th>Mrp</th>
                                        <th>Markup Price</th>
                                        <th>Selling Price</th>
                                        <th>Grace Coins</th>
                                        <th>Images</th>
                                        <th>Status</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>1</td>
                                        <td>
                                <Form.Control type="text" placeholder="unit" />
                                <Form.Select aria-label="product spec">
                                    <option>Open this select menu</option>
                                    <option value="1">Kg</option>
                                    <option value="2">Grm</option>
                                    <option value="3">Ltr</option>
                                </Form.Select>
                                </td>
                                <td><Form.Control type="text" placeholder="ref code" /></td>
                                <td><Form.Control type="text" placeholder="Pack" /></td>
                                <td><Form.Control type="text" placeholder="Mrp" /></td>
                                <td><Form.Control type="text" placeholder="Markup" /></td>
                                <td><Form.Control type="text" placeholder="Selling" /></td>
                                <td><Form.Control type="text" placeholder="Coins" /></td>
                                <td><Form.Control type="file" placeholder="Images" /></td>
                                <td><Form.Control type="checkbox" placeholder="Status" /></td>
                                <td><Button variant="danger">Delete</Button></td>
                                </tr>
                                <tr>
                                    <td>1</td>
                                    <td>
                                <Form.Control type="text" placeholder="unit" />
                                <Form.Select aria-label="product spec">
                                    <option>Open this select menu</option>
                                    <option value="1">Kg</option>
                                    <option value="2">Grm</option>
                                    <option value="3">Ltr</option>
                                </Form.Select>
                                </td>
                                <td><Form.Control type="text" placeholder="ref code" /></td>
                                <td><Form.Control type="text" placeholder="Pack" /></td>
                                <td><Form.Control type="text" placeholder="Mrp" /></td>
                                <td><Form.Control type="text" placeholder="Markup" /></td>
                                <td><Form.Control type="text" placeholder="Selling" /></td>
                                <td><Form.Control type="text" placeholder="Coins" /></td>
                                <td><Form.Control type="file" placeholder="Images" /></td>
                                <td><Form.Control type="checkbox" placeholder="Status" /></td>
                                <td><Button variant="danger">Delete</Button></td>
                                </tr>
                                </tbody>
                            </Table>
                        </Row>
                    </Form>
                    </Col>          
                </Row>
            </Container>
            );
}

export default AddProduct;
